module.exports = __webpack_public_path__ + "img/res.bbad0a75.svg";